import express, { Router } from 'express';

import * as documentsValidation from '@/modules/documents/documents.validation';
import * as documentsController from '@/modules/documents/documents.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.DOCUMENTS, ACTIONS.READ),
    validateMiddleware(documentsValidation.getDocuments),
    documentsController.getDocuments,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.DOCUMENTS, ACTIONS.CREATE),
    validateMiddleware(documentsValidation.createDocuments()),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'companyId' }),
    documentsController.createDocuments,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(
      MODULE_LIST.DOCUMENTS,
      ACTIONS.READ,
    ),
    validateMiddleware(documentsValidation.getDocumentsById),
    documentsController.getDocumentsById,
  )
  .patch(
    userAuthAndCheckPermissions(
      MODULE_LIST.DOCUMENTS,
      ACTIONS.UPDATE,
    ),
    validateMiddleware(documentsValidation.updateDocuments()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    documentsController.updateDocuments,
  )
  .delete(
    userAuthAndCheckPermissions(
      MODULE_LIST.DOCUMENTS,
      ACTIONS.DELETE,
    ),
    validateMiddleware(documentsValidation.deleteDocumentsById),
    documentsController.deleteDocumentsById,
  );

export default router;
